import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ChangePassword from './pages/auth/ChangePassword';
import Profile from './pages/Profile';
import Preferences from './pages/Preferences';
import Users from './pages/admin/Users';
import AdminRoute from './components/common/AdminRoute';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import { AvatarProvider } from './contexts/AvatarContext';
import { DomainSecurity } from './utils/domainSecurity';
import { NetworkSecurity } from './utils/networkSecurity';
import { CSRFProtection } from './utils/csrfProtection';
import './App.css';

function App() {
  // Initialize security measures
  useEffect(() => {
    // Domain validation should be first
    if (!DomainSecurity.validateDomain()) {
      // If domain validation fails, the DomainSecurity class will handle the redirect
      return;
    }
    
    // Initialize other security measures
    NetworkSecurity.initializeNetworkSecurity();
    CSRFProtection.initializeCSRFProtection();
  }, []);

  return (
    <AuthProvider>
      <AvatarProvider>
        <ToastProvider>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
            <Router>
              <Navbar />
              <main className="flex-1 pt-16 pb-16">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/" element={<AdminRoute><Home /></AdminRoute>} />
                <Route path="/profile" element={<AdminRoute><Profile /></AdminRoute>} />
                <Route path="/preferences" element={<AdminRoute><Preferences /></AdminRoute>} />
                <Route path="/admin/users" element={<AdminRoute><Users /></AdminRoute>} />
              </Routes>
            </main>
            <Footer />
          </Router>
        </div>
      </ToastProvider>
      </AvatarProvider>
    </AuthProvider>
  );
}

export default App;